export default function HushHotelIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="10" fill="#2A1A44" />
      <rect x="4" y="44" width="56" height="16" rx="3" fill="#4A2A3A" />
      <path d="M17 52V18a15 15 0 0 1 30 0v34Z" fill="#6B3F2A" />
      <path d="M21 52V20a11 11 0 0 1 22 0v32Z" fill="#8A5238" />
      <rect x="25" y="20" width="14" height="7" rx="3" fill="#FFD86A" />
      <circle cx="40" cy="38" r="2.2" fill="#FFD86A" />
      <path d="M44 34c0-7 5-11 9-11s9 4 9 11v12l-3-2-3 2-3-2-3 2-3-2-3 2Z" fill="#4FE3FF" opacity="0.95" />
      <circle cx="50" cy="32" r="1.8" fill="#1A2A4A" />
      <circle cx="56" cy="32" r="1.8" fill="#1A2A4A" />
      <path d="M50.5 37q2.5 2.5 5 0" stroke="#1A2A4A" strokeWidth="1.6" fill="none" strokeLinecap="round" />
      <circle cx="10" cy="12" r="1.4" fill="#FFF3B0" />
      <circle cx="54" cy="9" r="1.2" fill="#FFF3B0" />
      <circle cx="8" cy="30" r="1" fill="#FFF3B0" />
    </svg>
  );
}
